var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <textarea type=\"text\" class=\"form-control\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" placeholder=\"{{ vm.settings.placeholderText }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\" rows=\"10\">\n    </textarea> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaTextArea/lbaTextArea.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaTextArea/lbaTextArea.html
// module id = 369
// module chunks = 0